import type {
  WorkspaceLinkedDataSourceApi,
  WorkspaceLinkedDataSourceListResponseApi,
} from "./workspaceDataSources.types";

/** catalog_key → canonical domain label shown below the connector name. */
export const CATALOG_DOMAIN_MAP: Record<string, string> = {
  tableau: "tableau.com",
  hubspot: "hubspot.com",
  slack: "slack.com",
  snowflake: "snowflake.com",
  bigquery: "bigquery.com",
  powerbi: "powerbi.microsoft.com",
  salesforce: "salesforce.com",
  qlik: "qlik.com",
};

/**
 * Figma 2814-153875 — 6 linked connections shown on the Marketing ops workspace
 * Data sources tab.
 *
 * `id` = workspace_connectors join-row id; `connection_id` = connector_connections.id
 * (same shape as backend WorkspaceDataSourceItem).
 */
export const FIGMA_WORKSPACE_LINKED_DATA_SOURCES: WorkspaceLinkedDataSourceApi[] =
  [
    {
      id: "wc-tableau-production",
      connection_id: "conn-tableau-production",
      connection_name: "Tableau - production",
      catalog_display_name: "Tableau",
      catalog_key: "tableau",
      icon_url: "/logos/tableau.svg",
      domain: "tableau.com",
      status: "connected",
    },
    {
      id: "wc-hubspot-1",
      connection_id: "conn-hubspot-1",
      connection_name: "Hubspot",
      catalog_display_name: "Hubspot",
      catalog_key: "hubspot",
      icon_url: "/logos/hubspot.svg",
      domain: "hubspot.com",
      status: "connected",
    },
    {
      id: "wc-slack-1",
      connection_id: "conn-slack-1",
      connection_name: "Slack",
      catalog_display_name: "Slack",
      catalog_key: "slack",
      icon_url: "/logos/slack.svg",
      domain: "slack.com",
      status: "connected",
    },
    {
      id: "wc-tableau-finance",
      connection_id: "conn-tableau-finance",
      connection_name: "Tableau - finance",
      catalog_display_name: "Tableau",
      catalog_key: "tableau",
      icon_url: "/logos/tableau.svg",
      domain: "tableau.com",
      status: "connected",
    },
    {
      id: "wc-snowflake-production",
      connection_id: "conn-snowflake-production",
      connection_name: "Snowflake",
      catalog_display_name: "Snowflake",
      catalog_key: "snowflake",
      icon_url: "/logos/snowflake.svg",
      domain: "snowflake.com",
      status: "connected",
    },
    {
      id: "wc-bigquery-1",
      connection_id: "conn-bigquery-1",
      connection_name: "Big query",
      catalog_display_name: "BigQuery",
      catalog_key: "bigquery",
      icon_url: "/logos/bigquery.svg",
      domain: "bigquery.com",
      status: "connected",
    },
  ];

export const mockListWorkspaceLinkedDataSources = async (
  _workspaceId: string,
  q?: string,
): Promise<WorkspaceLinkedDataSourceListResponseApi> => {
  await new Promise((resolve) => setTimeout(resolve, 150));

  const query = (q ?? "").trim().toLowerCase();
  const items =
    query.length === 0
      ? FIGMA_WORKSPACE_LINKED_DATA_SOURCES
      : FIGMA_WORKSPACE_LINKED_DATA_SOURCES.filter((item) =>
          item.connection_name.toLowerCase().includes(query),
        );

  return { items, total: items.length };
};
